import {
  AUTO_SIZED_COLUMNS_DEFAULT,
  type TableCommandFactory,
} from 'components/Table/model/TableModel';
import { saveTableSettings } from 'components/Table/model/commands/saveTableSettings';
import { record } from 'fp-ts';
import { requestAutoSize } from './requestAutoSize';

export const restoreTableSettings: TableCommandFactory =
  (cmdContext, dispatch) => async () => {
    cmdContext.updateState((draft) => {
      draft.settings = record.empty;
    });
    cmdContext.onRestoreSettings?.();
    if (AUTO_SIZED_COLUMNS_DEFAULT) {
      dispatch(requestAutoSize);
    }
    await dispatch(saveTableSettings, { settings: null });
  };
